// store/reducers/roomReducer.js
import { SET_CHOOSE_ROOM } from "../action/chooseRoomActions";

const initialState = {
  roomId: null,
  room: null,
  label: null,
  date: null,
  roomHistoryId: null,
};

const chooseRoomReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CHOOSE_ROOM:
      // logika untuk menangani SET_CHOOSE_ROOM
      return {
        ...state,
        roomId: action.payload.roomId,
        room: action.payload.room,
        label: action.payload.label,
        date: action.payload.date,
        roomHistoryId : action.payload.roomHistoryId
      };
    // case lainnya
    default:
      return state;
  }
};

export default chooseRoomReducer;
